import { useTranslation } from 'react-i18next';
import { CareerAdvisorAvailability } from '../../../services/career-advisor.service';
import { CareerAdvisorStage } from './CareerAdvisorStage';

interface CareerAdvisorBlockProps {
  invitationToken: string;
  availability: CareerAdvisorAvailability;
  /** Called after a coaching session is evaluated, so the parent can
   *  refetch the candidate's remaining quota. */
  onSessionFinished?: () => void;
}

/**
 * Interview Coach experience when the workspace has hired the agent.
 * Shown below “How the Assessment Looks”; consent lives in InterviewConsentGate.
 */
export const CareerAdvisorBlock = ({
  invitationToken,
  availability,
  onSessionFinished,
}: CareerAdvisorBlockProps) => {
  const { t } = useTranslation('interview');

  return (
    <div className="w-full">
      <h3 className="text-xl md:text-2xl font-bold text-dark-invirtus font-heading tracking-tight mb-2">
        {t('career_advisor.title')}
      </h3>
      <p className="text-dark-invirtus/65 text-sm font-body leading-relaxed mb-6">
        {t('career_advisor.description')}
      </p>

      <CareerAdvisorStage
        invitationToken={invitationToken}
        availability={availability}
        onSessionFinished={onSessionFinished}
      />
    </div>
  );
};
